import * as actions from './common.action';
import inicialState from './common.state';
import cloneDeep from 'lodash/cloneDeep';

const commonReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.ATUALIZAR_IDIOMA:
      return {
        ...state,
        lang: action.payload.lang
      };
    case actions.ATUALIZAR_AUTOTEXTO:
      return {
        ...state,
        atualizaAutotexto: action.payload.atualizaAutotexto
      };
    case actions.SHOW_FADE_CARREGANDO:
      return {
        ...state,
        showCarregando: action.payload.showCarregando
      };
    case actions.CLOSE_CARREGANDO:
      return {
        ...state,
        closeCarregando: action.payload.closeCarregando
      };
    case actions.SHOW_SPLASH:
      return {
        ...state,
        splash: action.payload.splash
      };
    case actions.SHOW_FADE_MODAL:
      return {
        ...state,
        showModal: action.payload.showModal
      };
    case actions.SHOW_ALERTA:
      return {
        ...state,
        tipoAlerta: action.payload.tipoAlerta,
        mensagemAlerta: action.payload.mensagemAlerta,
        timeoutAlerta: action.payload.timeoutAlerta,
        idAlerta: action.payload.idAlerta,
        minWidth: action.payload.minWidth
      };
    case actions.AVANCAR_PAGINA_LISTAGEM:
      return {
        ...state,
        pagina: action.payload.pagina
      };
    case actions.PREENCHER_SELECT_COLORACAO:
      return {
        ...state,
        coloracoes: action.payload.coloracoes
      };
    case actions.PREENCHER_SELECT_ANTIGENOS:
      return {
        ...state,
        antigenos: action.payload.antigenos
      };
    case actions.PREENCHER_ATALHO:
      return {
        ...state,
        atalho: action.payload.atalho
      };
    case actions.MUDAR_STATUS_MODAL_RECOLHIMENTO_MULTI:
      return {
        ...state,
        modalRecolhimentoMulti: action.payload.modalRecolhimentoMulti
      };
    case actions.MUDAR_STATUS_MODAL_ENTREGA:
      return {
        ...state,
        modalEntrega: action.payload.modalEntrega,
        laudoEntrega: action.payload.laudoEntrega
      };
    case actions.MODAL_SOUL:
      return {
        ...state,
        modalSoul: action.payload.modalSoul,
      };
    case actions.MUDAR_STATUS_MODAL_IMPRIMIR:
      return {
        ...state,
        modalImprimir: action.payload.modalImprimir,
        laudoImprimir: action.payload.laudoImprimir
      };
    case actions.PREENCHER_IMPRESSORAS:
      return {
        ...state,
        impressoras: action.payload.impressoras
      };
    case actions.PREENCHER_TEXTO_PROTOCOLO_MATERIAL:
      return {
        ...state,
        textoProtocoloEntregaMaterial:
          action.payload.textoProtocoloEntregaMaterial
      };
    case actions.LOAD_LISTAGEM:
      return {
        ...state,
        loadListagem: action.payload.loadListagem
      };
    case actions.ATUALIZAR_NUMERO_REGISTROS:
      return {
        ...state,
        listagemTotal: action.payload.listagemTotal,
        listagemExibido: action.payload.listagemExibido
      };
    case actions.MUDAR_ETAPA:
      return {
        ...state,
        etapa: action.payload.etapa
      };
    case actions.PREENCHER_FILTROS:
      return {
        ...state,
        filtros: action.payload.filtros
      };
    case actions.PREENCHER_FILTROS_EXTERNO:
      return {
        ...state,
        filtrosExterno: action.payload
      };
    case actions.PREENCHER_FAVORITOS:
      return {
        ...state,
        favoritos: action.payload.favoritos
      };
    case actions.PREENCHER_LISTAGEM:
      return {
        ...state,
        listagem: action.payload.listagem
      };
    case actions.PREENCHER_ORDENACAO:
      return {
        ...state,
        ordenacao: action.payload.ordenacao,
        sentidoOrdenacao: action.payload.sentidoOrdenacao
      };
    case actions.ATUALIZAR_ALTURA:
      return {
        ...state,
        altura: action.payload.altura
      };
    case actions.ATUALIZAR_DETALHES:
      return {
        ...state,
        detalhes: action.payload.detalhes
      };
    case actions.ATUALIZAR_LAUDO_DETALHES:
      let draft = state.detalhes;
      if (draft && draft.laudo) {
        draft.laudo = Number(action.payload.laudo);
      }
      return {
        ...state,
        detalhes: draft
      };
    case actions.ATUALIZAR_LAUDO_SELECIONADO:
      return {
        ...state,
        laudoSelecionado: action.payload.laudoSelecionado
      };
    case actions.EDITOR_CARREGADO:
      return {
        ...state,
        editorCarregado: action.payload.editorCarregado
      };

    case actions.MUDAR_STATUS_MODAL_FATURAMENTO:
      return {
        ...state,
        modalFaturamento: action.payload.modalFaturamento
      };
    case actions.MUDAR_STATUS_LAUDO_FATURADO:
      return {
        ...state,
        laudoFaturado: action.payload.laudoFaturado
      };
    case actions.ADICIONAR_FRASCO:
      return {
        ...state,
        frascosGravados: action.payload.frascosGravados
      };
    case actions.ADICIONAR_NOVO_FRASCO:
      return {
        ...state,
        frascosNovos: action.payload.frascosNovos
      };
    case actions.SHOW_EDITOR:
      if (!action.payload.showEditor) {
        var filtro = document.getElementById('filtro-nrexame');
        if (filtro) {
          filtro.focus();
        }
      }
      return {
        ...state,
        showEditor: action.payload.showEditor
      };
    case actions.TEXTO_INICIAL:
      return {
        ...state,
        textoInicial: action.payload.textoInicial
      };

    case actions.AUTO_SAVE_EDITOR:
      return {
        ...state,
        autosaveEditor: action.payload.autosaveEditor
      };
    case actions.ETAPA_ATUAL:
      return {
        ...state,
        etapaAtual: action.payload.etapaAtual
      };
    case actions.PREENCHER_NAO_CONFORMIDADES:
      return {
        ...state,
        inconformidades: action.payload.inconformidades
      };
    case actions.BLOQUEAR_RECEBIMENTO:
      return {
        ...state,
        bloquearRecebimento: action.payload.bloquearRecebimento
      };
    case actions.PREENCHER_TOTAL_MENSAGENS:
      return {
        ...state,
        totalMensagens: action.payload.totalMensagens
      };
    case actions.SET_TIMEOUT_TOTAL_MENSAGENS:
      return {
        ...state,
        timeoutTotalMensagens: action.payload.timeoutTotalMensagens
      };
    case actions.MUDAR_STATUS_MODAL_MENSAGEM:
      return {
        ...state,
        modalMensagens: action.payload.modalMensagens,
        laudoModalMensagens: action.payload.laudoModalMensagens
      };
    case actions.MUDAR_STATUS_MODAL_CERTIFICACAO_DIGITAL:
      return {
        ...state,
        modalCertificacaoDigital: action.payload.modalCertificacaoDigital,
      };
    case actions.TOTAL_CERTIFICADOS_PENDENTES:
      return {
        ...state,
        totalCertificadosPendentes: action.payload.totalCertificadosPendentes,
      };
    case actions.PREENCHER_EXAMES_CONCLUIDOS:
      return {
        ...state,
        exames: action.payload.exames
      };
    case actions.EXAME_SELECIONADO:
      return {
        ...state,
        exameVincular: action.payload.exameVincular
      };
    case actions.PREENCHER_HISTORICO_INCONFORMIDADES:
      return {
        ...state,
        historicoInconformidades: action.payload.historico
      };
    case actions.PREENCHER_MEDICOS:
      return {
        ...state,
        medicos: action.payload.medicos
      };
    case actions.SET_MEDICO_PADRAO_FATURAMENTO:
      return {
        ...state,
        medPadraoFat: action.payload.medPadraoFat,
        fatMedicoPadrao: action.payload.fatMedicoPadrao
      };
    case actions.ARGUMENTOS_SALVAR_ETAPA_LAUDO:
      return {
        ...state,
        laudarEtapaRequest: action.payload.laudarEtapaRequest
      };
    case actions.ATUALIZAR_LARGURA_EDITOR:
      return {
        ...state,
        larguraEditor: action.payload.larguraEditor
      };
    case actions.ALTERAR_AUTOSAVE_TEXTO_LAUDO:
      return {
        ...state,
        autoSaveAtivo: action.payload.autoSaveAtivo
      };
    case actions.ALTERAR_VISIBILIDADE_ABAS:
      return {
        ...state,
        visibilidadeListaLaminas: action.payload.visibilidadeListaLaminas,
        visibilidadeAutotexto: action.payload.visibilidadeAutotexto,
        visibilidadeListagemAnexo: action.payload.visibilidadeListagemAnexo,
        visibilidadeLaudosAnteriores:
          action.payload.visibilidadeLaudosAnteriores,
        visibilidadeFrascos: action.payload.visibilidadeFrascos,
        visibilidadeHistoricoLaudo: action.payload.visibilidadeHistoricoLaudo,
        visibilidadeMultiplosExame: action.payload.visibilidadeMultiplosExame
      };
    case actions.ATUALIZAR_LISTAGEM_MULTIPLOS_EXAMES:
      return {
        ...state,
        listagemMultiplosExames: action.payload.listagemMultiplosExames
      };
    case actions.PREENCHER_TOTAL_NAO_CONFORMIDADES:
      return {
        ...state,
        totalNaoConformidades: action.payload.totalNaoConformidades
      };
    case actions.EXAME_FINALIZADO:
      return {
        ...state,
        exameFinalizado: action.payload.exameFinalizado
      };
    case actions.EXAME_ENTREGUE:
      return {
        ...state,
        exameEntregue: action.payload.exameEntregue
      };
    case actions.PREENCHER_GRUPO_USUARIO: {
      return {
        ...state,
        grupoUsuarios: action.payload.grupoUsuarios
      };
    }
    case actions.PREENCHER_PLAINTEXT: {
      return {
        ...state,
        plainTextLaudo: action.payload.plainTextLaudo
      };
    }
    case actions.PREENCHER_DRAGGABLE_PANEL_CONTENT: {
      return {
        ...state,
        draggablePanelContent: action.payload.draggablePanelContent,
        draggablePanelTitle: action.payload.draggablePanelTitle
      };
    }
    case actions.ATUALIZAR_LISTAGEM_RASTREABILIDADE:
      return {
        ...state,
        listagemRastreabilidade: action.payload.listagemRastreabilidade
      };
    case actions.MEDICO_PADRAO_MACROSCOPIA:
      return {
        ...state,
        medicoPadraoMacroscopia: action.payload.medicoPadraoMacroscopia
      };
    case actions.ATUALIZAR_STATUS_ETAPAS_LAUDO:
      let listagem = cloneDeep(state.listagem);
      let index = listagem.findIndex(
        item => item.laudo === action.payload.laudo
      );
      if (index > -1) {
        listagem[index].etapas = action.payload.etapas;
      }

      let detalhes = cloneDeep(state.detalhes);
      if (!!detalhes && detalhes.laudo === action.payload.laudo) {
        detalhes.etapas = action.payload.etapas;
      }

      return {
        ...state,
        listagem: listagem,
        detalhes: detalhes
      };
    case actions.EVENTO_KEYUP_DISPARADO_EDITOR:
      return {
        ...state,
        eventokeyUpFoiDisparadoNoEditor:
          action.payload.eventokeyUpFoiDisparadoNoEditor
      };
    case actions.EDITOR_INICIALIZADO:
      return {
        ...state,
        editorInicializado: action.payload.editorInicializado
      };
    case actions.ATUALIZAR_NUMERO_EXAME: {
      let listagem = cloneDeep(state.listagem);
      let index = listagem.findIndex(
        item => item.laudo === action.payload.laudo
      );

      if (index > -1) {
        listagem[index].nrExame = action.payload.numeroExame;
      }

      return {
        ...state,
        listagem
      };
    }
    case actions.ATUALIZAR_LISTAGEM_DOCUMENTOS_EXTERNOS:
      return {
        ...state,
        listagemDocumentosExternos: action.payload.listagemDocumentosExternos
      };

    case actions.MUDAR_STATUS_MODAL_OBSERVACOES:
      return {
        ...state,
        modalObservacoes: action.payload.modalObservacoes,
        laudo: action.payload.laudo
      };

    case actions.ATUALIZAR_PROPS_ITEM_LISTAGEM: {
      let listagem = cloneDeep(state.listagem);
      let index = listagem.findIndex(
        item => item.laudo === action.payload.laudo
      );
      if (
        index > -1 &&
        listagem[index][action.payload.nomePropriedade] !== undefined
      ) {
        listagem[index][action.payload.nomePropriedade] =
          action.payload.novoValor;
      }

      return {
        ...state,
        listagem
      };
    }

    case actions.SHOW_MODAL_IMUNO:
      return {
        ...state,
        modalRequisicaoImuno: action.payload.modalRequisicaoImuno,
      };
    case actions.MUDAR_STATUS_MODAL_IMUNO:
      return {
        ...state,
        modalRequisicaoImuno: !state.modalRequisicaoImuno,
        laudo: action.payload.laudo
      };
    case actions.DADOS_HOSPITAL:
      return {
        ...state,
        dadosGeraisHospital: action.payload.dadosGeraisHospital
      };
    case actions.PREENCHER_HISTORICO_TOTAL_LAUDOS_ANTERIORES:
      return {
        ...state,
        quantidadeLaudosAnteriores: action.payload.quantidadeLaudosAnteriores
      };
    case actions.PREENCHER_HISTORICO_TOTAL_LAUDOS_EM_ABERTO:
      return {
        ...state,
        quantidadeLaudosEmAberto: action.payload.quantidadeLaudosEmAberto
      };
    case actions.PREENCHER_USUARIOS:
      return {
        ...state,
        usuarios: action.payload.usuarios
      };
    case actions.CHANGE_RTF:
      return {
        ...state,
        rtf: action.payload.rtf
      };
    case actions.FECHAR_TELA:
      return {
        ...state,
        fecharTela: action.payload.fecharTela
      };
    case actions.ID_RTF:
      return {
        ...state,
        idRtf: action.payload.idRtf
      };
    default:
      return state;
  }
};

export default commonReducer;



// WEBPACK FOOTER //
// ./src/app/common/common.reducer.js